import { ClassNamesConfig, Props } from "react-select";
import Select from "../Select";
import { Control, Controller, Path } from "react-hook-form";
import { ErrorMessage } from "../ErrorMessage";

export type SelectControllerProps<T extends {}>  = {
  control: Control<T>
  name: Path<T>
  label?: string
  markAsRequired?: boolean
  className?: string
  inputClassName?: string
  errorMessage?: string
  triggerOnChange?: (e: any) => void
  options: {label: string | JSX.Element, value: string | number}[]
  customStyles?: ClassNamesConfig<unknown>;
} & Props

const SelectController = <T extends {}>({
  control,
  name,
  label,
  markAsRequired,
  className,
  inputClassName,
  errorMessage,
  triggerOnChange,
  options,
  customStyles,
  ...props
}: SelectControllerProps<T>) => {
  return  (
    <div className={className}>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, ...field } }) => (
          <Select
            {...field}
            label={label}
            markAsRequired={markAsRequired}
            className={inputClassName}
            options={options}
            customStyles={customStyles}
            onChange={(e) => {
              onChange(e);
              triggerOnChange && triggerOnChange(e);
            }}
            {...props}
          />
        )}
      />
      {errorMessage ? <ErrorMessage name={name} message={errorMessage} /> : null}
    </div>
  )
}

export default SelectController
